import { SmallPortalTooltip } from '../../Tooltip';
import styled, { css } from 'styled-components';
import { LEARNER_STATUS } from '../../../api/admin';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import { CellContext } from '@tanstack/react-table';
import { LearnerProgress } from '.';
import { TooltipDetail, TooltipTitle } from './Tooltip';
dayjs.extend(utc);
dayjs.extend(relativeTime);

const TooltipContent = styled.div`
  padding: 10px;
  max-width: 400px;
`;

const StatusPill = styled.div<{ status: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;

  ${({ status, theme }) => {
    const isInactive = status.includes('Inactive for');
    if (isInactive) {
      return css`
        background-color: ${theme.colors.buttonSecondary};
        color: ${theme.colors.buttonTextColor};
      `;
    }

    switch (status) {
      case LEARNER_STATUS.INVITED:
        return css`
          background-color: ${theme.colors.secondary};
          color: ${theme.colors.buttonTextColor};
        `;
      case LEARNER_STATUS.ONBOARDED:
        return css`
          background-color: ${theme.colors.bgDefault};
          color: ${theme.colors.textPrimary};
        `;
      case LEARNER_STATUS.ACTIVE:
        return css`
          background-color: ${theme.colors.primary};
          color: ${theme.colors.buttonTextColor};
        `;
      case LEARNER_STATUS.INACTIVE: // this doesn't work
        return css`
          background-color: ${theme.colors.bgDefaultSecondary};
          color: ${theme.colors.textRegular};
        `;
      case LEARNER_STATUS.INVITE_EXPIRED:
        return css`
          background-color: ${theme.colors.bgDefaultSecondary};
          color: ${theme.colors.textRegular};
        `;
      case LEARNER_STATUS.COHORT_ENDED:
        return css`
          background-color: ${theme.colors.bgDefaultSecondary};
          color: ${theme.colors.textRegular};
        `;
      default:
        return css`
          background-color: ${theme.colors.bgDefaultSecondary};
          color: ${theme.colors.textRegular};
        `;
    }
  }}
`;

export default function StatusCell(
  info: CellContext<LearnerProgress, LEARNER_STATUS>
) {
  const status = info.getValue();
  const user = info.row.original;
  const uniqueId = `status-tooltip-${info.row.id}`;

  return (
    <>
      <StatusPill status={status} data-tooltip-id={uniqueId}>
        {status}
      </StatusPill>
      <SmallPortalTooltip anchorSelect={`[data-tooltip-id="${uniqueId}"]`}>
        <TooltipContent>
          <TooltipTitle>Status Details</TooltipTitle>
          <TooltipDetail>
            Invited:{' '}
            {user.invitedAt
              ? dayjs.utc(user.invitedAt).format('MMM D, YYYY HH:mm UTC')
              : 'Unknown'}
          </TooltipDetail>
          {user?.onboardedAt && (
            <>
              <TooltipDetail>
                Onboarded:{' '}
                {user.onboardedAt
                  ? dayjs.utc(user.onboardedAt).format('MMM D, YYYY HH:mm UTC')
                  : 'Unknown'}
              </TooltipDetail>
            </>
          )}
        </TooltipContent>
      </SmallPortalTooltip>
    </>
  );
}
